"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBottomBarIcon = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const pianoWorldMenu_1 = require("../../../world-menus/pianoWorldMenu");
const createBottomBarIcon = ({ condition, imagePath, inputCollectionID, isSelected, onClick, x, y, }) => {
    (0, pixel_pigeon_1.createSprite)({
        animationID: () => {
            const isSelectedValue = typeof isSelected === "function" ? isSelected() : isSelected;
            return isSelectedValue ? "selected" : "unselected";
        },
        animations: [
            {
                frames: [
                    {
                        height: 22,
                        sourceHeight: 22,
                        sourceWidth: 22,
                        sourceX: 0,
                        sourceY: 0,
                        width: 22,
                    },
                ],
                id: "unselected",
            },
            {
                frames: [
                    {
                        height: 22,
                        sourceHeight: 22,
                        sourceWidth: 22,
                        sourceX: 22,
                        sourceY: 0,
                        width: 22,
                    },
                ],
                id: "selected",
            },
        ],
        coordinates: {
            condition,
            x: x - 1,
            y: y - 1,
        },
        imagePath,
    });
    (0, pixel_pigeon_1.createButton)({
        coordinates: {
            condition,
            x: x - 1,
            y: y - 1,
        },
        height: 22,
        onClick,
        width: 22,
    });
    (0, pixel_pigeon_1.createInputPressHandler)({
        condition: () => {
            if (typeof condition === "undefined" || condition()) {
                return pianoWorldMenu_1.pianoWorldMenu.isOpen() === false;
            }
            return false;
        },
        inputCollectionID,
        onInput: onClick,
    });
};
exports.createBottomBarIcon = createBottomBarIcon;
